import Navigation from './Navigation';

export default function Hero() {
  return (
    <section className="relative h-[27vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0A1628] via-[#1A2332] to-[#2A2A2A] mx-6 md:mx-8 mt-6 rounded-3xl shadow-lg" style={{ backgroundColor: '#f2f6f8' }}>
      <Navigation />
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      
      <div className="absolute left-6 md:left-12 top-1/2 -translate-y-1/2 z-10">
        <div className="flex items-center gap-6">
          <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-2 border-white/20">
            <img 
              src="https://static.readdy.ai/image/ed7d6e9501624c265bc1ac340fb9283d/9e298e98272b6454052af4ac8865b6ab.jpeg"
              alt="Okenna Okpareke"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <div className="text-white text-3xl md:text-5xl font-bold">
              Hello, I'm Okenna!
            </div>
            <p className="text-white text-xl md:text-2xl mt-2">
              Senior Product & <span className="font-bold text-[#FF6B4A]">UX Designer</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}